var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 524 511.64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M132.63 151.86c-4.48 4.29-11.57 4.12-15.83-.4-4.26-4.53-4.08-11.69.39-15.99L253.24 4.13C255.32 1.6 258.47 0 262 0c3.62 0 6.84 1.7 8.92 4.34l131.74 131.27c4.4 4.37 4.45 11.53.12 15.98a11.121 11.121 0 0 1-15.82.13L273.32 38.49v370.92c0 6.25-5.07 11.32-11.32 11.32-6.26 0-11.33-5.07-11.33-11.32V37.91L132.63 151.86zm368.72 246.7c0-6.25 5.07-11.33 11.32-11.33 6.26 0 11.33 5.08 11.33 11.33v101.76c0 6.25-5.07 11.32-11.33 11.32H11.33C5.07 511.64 0 506.57 0 500.32V398.56c0-6.25 5.07-11.33 11.33-11.33 6.25 0 11.32 5.08 11.32 11.33v90.43h478.7v-90.43z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.df8f4f2536bb73212ed234b5d0366278.svg";
export { ForwardRef as ReactComponent };